import { requiredStringValidator } from './requiredStringValidator';

export const emailValidator = requiredStringValidator
    .trim()
    .lowercase()
    .min(3, 'Email must be at least 3 characters')
    .max(256, 'Max email length is 256')
    .email('Please use a valid email address');
